import { WarningOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import CountryPreview from '@/components/CountryPreview';
import InfoBox from '@/components/InfoBox';
import VerifyListItem
  from '@/modules/proposalRequest/components/ProposalCreateForm/ProposalVerifyData/components/VerifyListItem';
import { renderMunicipality, renderProvince } from '@/utils/location';
import { getUserFullName } from '@/utils/userFullName';

import style from './index.less';

const MarriedInformationDetails = ({ value }) => {
  const { t } = useTranslation('proposalRequest');

  const isCuba = useMemo(() => value?.nationality === 'CU', [value?.nationality]);

  return (
    <div className={classNames(style.container, 'mb-4 rounded px-4 py-2')}>
      <VerifyListItem labelKey={t('civilStatus.information.title')} dots={false} className={'font-bold'}/>

      <VerifyListItem labelKey={t('fullName')} value={getUserFullName(value)}/>
      <VerifyListItem labelKey={t('dni.placeholder')} value={value?.idNumber}/>
      <VerifyListItem labelKey={t('civilStatus.information.occupation')} value={value?.occupation}/>
      <VerifyListItem labelKey={t('bornPlace')} value={<CountryPreview value={value?.bornPlace}/>}/>
      <VerifyListItem labelKey={t('nationality')} value={<CountryPreview value={value?.nationality}/>}/>
      <div className={classNames({ 'hidden': !isCuba })}>
        <VerifyListItem labelKey={t('province')} value={renderProvince(value?.address?.province)}/>
        <VerifyListItem labelKey={t('municipality')} value={renderMunicipality(value?.address?.municipality)}/>
      </div>
      <VerifyListItem labelKey={t('address')} value={value?.address?.abstract}/>

      <div className={'md:max-w-3/4'}>
        <InfoBox
          title={t('proposalRequest.form.partners.isMarried')}
          icon={<WarningOutlined/>}
          className="font-semibold"
          hideIcon={false}/>
      </div>
    </div>
  );

};

MarriedInformationDetails.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func
};

MarriedInformationDetails.defaultProps = {};

export default memo(MarriedInformationDetails);
